module.exports = __webpack_public_path__ + "static/media/MAP.1bf7b1ba.png";